/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Search_TitleInputs */

const en_seo_search_title = /** @type {(inputs: Seo_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search AI tools`)
};

const zh_seo_search_title = /** @type {(inputs: Seo_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索 AI 工具`)
};

/**
* | output |
* | --- |
* | "Search AI tools" |
*
* @param {Seo_Search_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_search_title = /** @type {((inputs?: Seo_Search_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Search_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_search_title(inputs)
	return zh_seo_search_title(inputs)
});
export { seo_search_title as "seo.search.title" }